.floating-label-input {
    width: 100%;
    padding: 16px;
    display: block;
    border: none;
    border: 1px solid #21242799;
    outline: none;
    border-radius: 4px;
    font-family: 'JosefinSans';
    font-size: 16px;
    color: #999;
    /* transition: 0.2s ease all; */
    /* pointer-events: none; */
    /* height: 40px; */
}